
const initialState = {
    Allcampaign:[]
  
  }
  
  const userCampaginReducer = (state = initialState, action) => {
    const { type, payload } = action
    
    switch (type) {
      case 'SET_ALL_CAMPAIGN': {
        return {
          ...state,
          Allcampaign: payload,
        
        }
      }
  
      default:
        return state
    }
  }
  
  export default userCampaginReducer
